// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"94c67523","839":"254b2c3e"}[chunkId] + ".chunk.js";
};